export class DuplicateAddressCheckRequest {
  businessId!: string;
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  latitude?: number;
  longitude?: number;
  radiusMeters?: number;
  excludePropertyId?: number;
}